import { KYC } from './Typeform/KYC';

const RegisterInvestor = () => {
  return (
    <KYC id='Vq71LgvW' />
  )
}

export default RegisterInvestor;
